import {REPORT_PREMIER_CANCELLATIONS} from '/enum/records.enum';

export default {
  reportName: REPORT_PREMIER_CANCELLATIONS,
};
